import { useMemo, useSyncExternalStore } from 'react';
import type { LobbySession } from './LobbySession.js';
import type { MeetingView } from '../ghost-meeting/types.js';

export interface UseMeetingSessionResult {
  /** Non-null only while the session is in the GhostMeeting phase. */
  view: MeetingView | null;
  onVote: (targetId: string) => void;
}

export function useMeetingSession(session: LobbySession): UseMeetingSessionResult {
  const snapshot = useSyncExternalStore(
    (cb) => session.subscribe(cb),
    () => session.getSnapshot(),
  );
  const onVote = useMemo(
    () => (targetId: string) => session.sendGhostMeetingVote(targetId),
    [session],
  );
  return { view: snapshot.meetingView, onVote };
}
